import axios from 'axios';

// Use relative /api so nginx in the container can proxy to backend
const API_URL = process.env.REACT_APP_API_URL || '/api';

type ApiRequestConfig = {
  preserveSessionOnAuthError?: boolean;
};

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

const AUTH_ERROR_CODES = new Set(['AUTH_REQUIRED', 'INVALID_TOKEN', 'TOKEN_EXPIRED']);
let authRedirectInProgress = false;

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const code = error.response?.data?.code;
    const preserveSessionOnAuthError = Boolean(
      (error.config as ApiRequestConfig | undefined)?.preserveSessionOnAuthError
    );

    if (status === 401 && AUTH_ERROR_CODES.has(code) && !preserveSessionOnAuthError) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');

      if (!authRedirectInProgress && window.location.pathname !== '/login') {
        authRedirectInProgress = true;
        window.location.assign('/login');
      }
    }
    return Promise.reject(error);
  }
);

export default api;
